/**
 * Which document types get ZUGFeRD/Factur-X XML embedded on PDF export.
 * Only invoices: Angebote, Auftragsbestätigungen, Lieferscheine etc. would otherwise be
 * booked as invoices by the recipient's e-invoice intake.
 */
export const ZUGFERD_EMBED_DOCUMENT_LABELS = new Set([
  'Rechnung',
  'Abschlagsrechnung',
  'Schlussrechnung',
  'Stornorechnung',
  'Gutschrift',
]);

export function shouldEmbedZugferd(documentTypeLabel: string): boolean {
  return ZUGFERD_EMBED_DOCUMENT_LABELS.has(documentTypeLabel.trim());
}
